import { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
    Alert,
    Button,
    ButtonGroup,
    Card,
    Container,
    Row,
    Col,
    Form,
    Modal,
    Spinner,
    Tooltip,
    OverlayTrigger,
    Dropdown,
} from "react-bootstrap";

import moment from "moment";

import toastr from "toastr";
import { Typeahead } from "react-bootstrap-typeahead";


//Tabla, Navbar y Sidebar
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import CustomTableBackendFilters from "../../../components/CustomTableBackendFilters";

//redux
import { getOrgs } from "../../../redux/organization/actions";
import { getLevel } from "../../../redux/evaluacion_desempenio/Level/actions";
import { getConfSmartEmpleados, resetConfSmart, resetConfSmartEmpleados } from "../../../redux/evaluacion_desempenio/ConfSmart/actions";
import CustomTable from "../../../components/CustomTable";
import { get_tasks } from "../../../redux/tasks/actions";
import FuncionesModal from "../../../components/evaluacion_desempenio/conf_smart/FuncionesModal";
import CreateConfModal from "../../../components/evaluacion_desempenio/conf_smart/CreateConfModal";
import { getFormType } from "../../../redux/evaluacion_desempenio/FormType/actions";




const ConfSmart = (props) => {
    const [show, setShow] = useState(true);
    const onShowSidebar = () => setShow(show ? false : true);

    //Variables para filtrado y paginación
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({});

    //Variables para editar
    const [edit, setEdit] = useState(false);
    const [index, setIndex] = useState(0);
    const [editItem, setEditItem] = useState({});
    const [searchFuncion, setSearchFuncion] = useState("");
    const [selectedFuncion, setSelectedFuncion] = useState([]);
    const [funcionesList, setFuncionesList] = useState([]);
    const [empresa, setEmpresa] = useState("");
    const [nivel, setNivel] = useState("");
    const [anio, setAnio] = useState(moment().format("YYYY"))
    const [empleadosList, setEmpleadosList] = useState([]);
    const [recargar, setRecargar] = useState(false);

    //Variables para el formulario
    const [showFormModal, setShowFormModal] = useState(false);
    const [showConfModal, setShowConfModal] = useState(false);

    //Redux
    const dispatch = useDispatch();

    const {
        loading,
        confSmartEmpleadosLength,
        confSmartEmpleados,
        confSmartError
    } = useSelector((store) => store.confSmart);

    const {
        loading: loadingLevels,
        levels
    } = useSelector((store) => store.level);

    const {
        orgs,
        loading: loadingOrgs
    } = useSelector((store) => store.orgs);


    const companiesOptions = orgs?.map((org) => ({
        id: org.id,
        label: org.nombre
    })) || [];

    const levelsOptions = levels?.map((level) => ({
        id: level.id,
        label: level.nombre
    })) || [];

    const yearsOptions = Array.from(
        { length: 5 },
        (_, i) => ({
            id: moment().year() - i,
            label: moment().year() - i
        })
    );

    useEffect(() => {
        dispatch(getOrgs(parseInt(2)))
        dispatch(getLevel())
        dispatch(get_tasks({ limit: 10, offset: 0 }, 2));
        dispatch(getFormType())
        dispatch(resetConfSmartEmpleados())
    }, []);

    useEffect(() => {
        if (empresa && ((nivel || anio || funcionesList.length > 0) || recargar)) {
            let req = {
                limit: limit,
                offset: offset,
            }
            req.empresa__id = empresa.id
            if (nivel) req.nivel = nivel.id
            if (anio) req.anio = anio
            if (funcionesList.length > 0) req.posicion__id = JSON.stringify(funcionesList.map(func => func.id))
            dispatch(getConfSmartEmpleados(req))
            recargar && setRecargar(false);
        } else if (!empresa) {
            dispatch(resetConfSmartEmpleados())
        }

    }, [empresa, nivel, offset, limit, anio, funcionesList, recargar]);

    useEffect(() => {
        dispatch(resetConfSmart())
    }, [])


    const pages = Math.ceil(
        confSmartEmpleados ? confSmartEmpleadosLength / limit : 0
    );



    const columns = [
        {
            Header: "Código",
            accessor: "codigo",
            Filter: ""
        },
        {
            Header: "Nombre",
            accessor: "nombre",
            Filter: ""
        },
        {
            Header: "Cargo",
            accessor: "puesto_nombre",
            Filter: ""
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                //agregar empleados a la lista
                <Form.Check
                    type="checkbox"
                    disabled={value.row.original.configuracion}
                    label={value.row.original.configuracion ? "Configuración Asignada" : ""}
                    id={`custom-checkbox-${value.row.original.id}`}
                    checked={empleadosList.some(emp => emp.id === value.row.original.id) || value.row.original.configuracion}
                    onChange={() => {
                        if (empleadosList.some(emp => emp.id === value.row.original.id)) {
                            setEmpleadosList(empleadosList.filter(emp => emp.id !== value.row.original.id));
                        } else {
                            setEmpleadosList([...empleadosList, value.row.original]);
                        }
                    }}
                />
            ),
        },
    ];



    //Funciones
    const onEdit = (item, index) => {
        setIndex(index);
        setEdit(true);
        setEditItem(item);
        setShowFormModal(true);
    };

    const handleFiltersChange = (newFilters) => {
        setFilters(newFilters);
        setOffset(0);
    };

    const _getLevels = (offs = offset, lim = limit) => {
        setOffset(offs);
        setLimit(lim);
    };


    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <h5 className="text-black-50 m-0 text-uppercase">
                        CONFIGURACIÓN SMART
                    </h5>

                    <hr />

                    <Alert variant="danger" className="mt-4 mb-1 mx-3" show={confSmartError}>
                        {confSmartError}
                    </Alert>

                    <Row className="mb-3">
                        <Form as={Row} className="p-3 w-100">
                            <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                                <Form.Label column sm="12" md="12">
                                    Empresa <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="d-flex align-items-center">
                                    <Typeahead
                                        id="empresa"
                                        name="empresa"
                                        className={`w-100 ${!empresa ? 'is-invalid' : ''}`}
                                        placeholder="Seleccione una empresa"
                                        options={companiesOptions}
                                        disabled={loadingOrgs || loading}
                                        onChange={(selected) => {
                                            setEmpresa(selected[0]);
                                            setEmpleadosList([]); // Reset selected employees when company changes
                                        }}
                                        defaultInputValue={""}
                                    >
                                    </Typeahead>
                                    {loadingOrgs && <Spinner animation="border" size="sm" className="ml-2" />}
                                </div>
                                {!empresa && (
                                    <div className="invalid-feedback d-block">
                                        Debe seleccionar una empresa para continuar.
                                    </div>
                                )}
                            </Form.Group>
                            <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                                <Form.Label column sm="12" md="12">
                                    Nivel
                                </Form.Label>
                                <div className="d-flex align-items-center">
                                    <Typeahead
                                        className="w-100"
                                        id="nivel"
                                        name="nivel"
                                        placeholder="Seleccione un nivel"
                                        options={levelsOptions}
                                        onChange={(selected) => {
                                            setNivel(selected[0]);
                                        }}
                                        defaultInputValue={""}
                                        disabled={loadingLevels || loading}
                                    >
                                    </Typeahead>
                                    {loadingLevels && <Spinner animation="border" size="sm" className="ml-2" />}
                                </div>

                            </Form.Group>
                            <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                                <Form.Label column sm="12" md="12">
                                    Función
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        className="ml-2 rounded-pill"
                                        onClick={() => setShowFormModal(true)}
                                        disabled={loading}
                                    >
                                        <i className="material-icons">add</i>
                                    </Button>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="funcion"
                                    className="mt-2"
                                    disabled
                                    placeholder="No hay función seleccionada"
                                    value={(funcionesList || [])?.map(f => f.label).join(", ")}
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                                <Form.Label column sm="12" md="12">
                                    Año
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    name="anio"
                                    className="col rounded-pill"
                                    placeholder="Año"
                                    value={anio}
                                    onChange={(e) => setAnio(e.target.value)}
                                    disabled={loading}
                                >
                                    <option value="">Seleccione un año</option>
                                    {yearsOptions.map((year) => (
                                        <option key={year.id} value={year.id}>
                                            {year.label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} sm={6} md={6} lg={6} className="mb-3">
                            </Form.Group>
                            <div className="d-flex justify-content-between align-items-center w-100 px-4">
                                <h5>Empleados Seleccionados: {empleadosList.length}</h5>
                                {empresa && empleadosList.length > 0 && (
                                    <Form.Group as={Col} sm={6} md={6} lg={6} className="mb-3 text-right">
                                        <Button className="rounded-pill" variant="primary" onClick={() => setShowConfModal(true)}>
                                            Crear Configuración
                                        </Button>
                                    </Form.Group>
                                )}
                            </div>

                        </Form>
                    </Row>

                    <Card className="border-0">
                        <Card.Body className="px-1 px-sm-2">
                            {!empresa ? (
                                <Alert variant="info" className="text-center">
                                    <i className="material-icons">info</i>
                                    {" "}Seleccione una empresa para ver los empleados disponibles.
                                </Alert>
                            ) : (
                                <CustomTable
                                    columns={columns}
                                    data={confSmartEmpleados || []}
                                    isLoadingData={loading}
                                />
                            )}
                        </Card.Body>
                    </Card>
                    <CustomPagint
                        limit={limit}
                        setLimit={setLimit}
                        offset={offset}
                        setOffset={setOffset}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        dataLength={confSmartEmpleadosLength}
                        pages={pages}
                        pagFunc={_getLevels}
                    />

                </Container>
                <FuncionesModal
                    showFormModal={showFormModal}
                    setShowFormModal={setShowFormModal}
                    funcionesList={funcionesList}
                    setFuncionesList={setFuncionesList}
                />
                <CreateConfModal
                    showFormModal={showConfModal}
                    setShowFormModal={setShowConfModal}
                    listEmpleados={empleadosList}
                    setEmpleadosList={setEmpleadosList}
                    data={{
                        empresa: empresa,
                        nivel: nivel,
                        anio: anio
                    }}
                    setRecargar={setRecargar}
                    recargar={recargar}
                />
            </div>
        </>
    );
};

export default ConfSmart;
